import { useSelector } from 'react-redux';

const Widget = () => {
	const { launchdarklyFlags } = useSelector(state => state);

	const isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
		const { DDC: { pushToGtmDataLayer } = {} } = window;
		// Adding the tracked flags to DDC.Flags
		window.DDC = window.DDC || {};
		window.DDC.Flags = {
			...(window.DDC.Flags || {}),
			...launchdarklyFlags
		};

		// Payload which gets send to GTM
		const payload = {
			event: 'ddc.launchdarkly',
			eventData: launchdarklyFlags
		};

		if (pushToGtmDataLayer) {
			pushToGtmDataLayer(payload);
		}
	}
	return null;
};

export default Widget;
